import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { DeviceAgentOption, DeviceType } from './types.ts'
import {ArrowLeft} from "lucide-react";

interface NewProps {
  device: DeviceType
  agents: DeviceAgentOption[]
}

export default function New({ device, agents }: NewProps) {
  return (
    <>
      <Head title="Nouveau terminal" />

        <div className="flex flex-col gap-6 p-8">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link href="/admin/devices">
                        <button className="rounded-lg border border-border p-2 text-foreground hover:bg-secondary transition-colors">
                            <ArrowLeft className="h-5 w-5" />
                        </button>
                    </Link>
                    <div>
                        <h1 className="text-3xl font-bold text-foreground">Ajouter un terminal</h1>
                    </div>
                </div>
            </div>

        <Form
          device={device}
          method="post"
          action="/admin/devices"
          submitText="Créer un terminal"
          agents={agents}
        />

      </div>
    </>
  )
}
